export const PageDataState = {
    Searchs: {
        ministry_name: {
            type: 'text',
            id: 'ministry_name',
            label: 'สังกัดกระทรวง',
            value: '',
            placeholder: 'สังกัดกระทรวง',
        },
        ministry_status: {
            type: 'select',
            id: 'ministry_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'สังกัดกระทรวง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}